import { jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useImperativeHandle, useEffect } from "react";
import { ControlContainer } from "../ControlContainer/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import { cn as clsx } from "../../helpers/react.js";
import { noop } from "../../helpers/utils.js";
import '../../assets/index8.css';const checkbox = "_checkbox_hi2xg_1";
const intermediate = "_intermediate_hi2xg_39";
const s = {
  checkbox,
  intermediate
};
const CheckboxInput = forwardRef(
  ({ type, className, checked, indeterminate, onChange = noop, ...props }, forwardedRef) => {
    const internalRef = useRef(null);
    useImperativeHandle(forwardedRef, () => internalRef.current, []);
    useEffect(() => {
      if (internalRef.current) {
        internalRef.current.indeterminate = Boolean(indeterminate);
      }
    }, [indeterminate]);
    return /* @__PURE__ */ jsx(
      "input",
      {
        ...props,
        onChange,
        ref: internalRef,
        type: "checkbox",
        checked: indeterminate ? false : checked,
        className: clsx(
          s.checkbox,
          {
            [s.intermediate]: indeterminate
          },
          className
        )
      }
    );
  }
);
const Checkbox = withThemeAndSize(
  forwardRef(({ disabled, checkboxState, checkboxClassName, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(ControlContainer, { ...rest, disabled, ref, children: /* @__PURE__ */ jsx(
      CheckboxInput,
      {
        disabled,
        checked: checkboxState === "intermediate" ? void 0 : checkboxState,
        indeterminate: checkboxState === "intermediate"
      }
    ) });
  })
);
export {
  Checkbox,
  CheckboxInput
};
